
import { computed, defineComponent } from 'vue'

export default defineComponent({
  props: {
    content: {
      type: String,
      default: ''
    },
  },

  setup (props, context) {
    const parseContent = computed(() => {
      return props.content.replace(/\s+(?=,)|^\s+|\s+$/g, '').replaceAll(',', ';\n')
    })

    return {
      parseContent,
    }
  }
})
